<template>
	<div
		v-if="isCommissioner"
		class="container mx-auto flex-grow-0"
		style="max-height: 10vh"
	>
		<div class="flex h-12 item-center justify-center">
			<div v-if="submission && submission.pick_data" class="my-auto">
				<button
					class="base-btn bg-green-600 hover:bg-green-900 ml-3"
					@click="
						() => {
							this.openSubmission = true;
						}
					"
				>
					{{ user_name(submission.pick_data.room_user_id) }}'s
					Submission is in
				</button>
				<SubmissionCard
					:submission="submission"
					:confirm="
						() => {
							this.$store.dispatch('confirm_pick');
						}
					"
					:reject="
						() => {
							this.$store.dispatch('reject_pick');
						}
					"
					:close="closeSubmission"
					v-if="openSubmission && submission"
				/>
			</div>
			<span class="my-auto" v-else-if="!hasDraftStarted"
				>Waiting for draft start</span
			>
			<div class="my-auto" v-else>
				Waiting for a submission from {{ current_picker.name }}
			</div>
		</div>
	</div>
</template>

<style lang="scss">
.start_draft {
	@apply bg-blue-600 hover:bg-blue-900;
}

.restart_draft {
	@apply bg-red-600 hover:bg-red-900;
}
</style>

<script>
import SubmissionCard from '@/components/commissioner/SubmissionCard';
import { mapState, mapGetters, mapMutations } from 'vuex';

export default {
	components: { SubmissionCard },
	computed: {
		...mapState({
			isCommissioner: state => state.user.isCommissioner,
			current_user_id: state => state.user.id,
			submission: state => state.commissioner.submission,
		}),
		...mapGetters(['hasDraftStarted', 'user_name', 'player_name']),
		...mapState(['current_picker']),
		...mapMutations(['confirm_pick', 'reject_pick']),
	},
	props: {
		room_id: String,
	},
	data() {
		return {
			openSubmission: false,
		};
	},
	channels: {
		UserChannel: {
			connected() {},
			received(data) {
				this.$store.commit('set_submission', data);
			},
		},
	},
	mounted() {
		this.subscribe();
		this.$store.dispatch('latest_submission');
	},
	updated() {
		this.subscribe();
	},
	methods: {
		subscribe() {
			this.current_user_id &&
				this.$cable.subscribe({
					channel: 'UserChannel',
					user_id: this.current_user_id,
				});
		},
		closeSubmission() {
			this.openSubmission = false;
		},
	},
};
</script>
